import { useState } from "react";

const navItems = [
  {
    name: "explore",
    description: "the algorithm, explore all posts on all feeds",
  },
  {
    name: "following",
    description: "the people you are following, in latest to oldest posts",
  },
  {
    name: "team",
    description: "posts from your team or circle, in latest to oldest",
  },
];

export default function Menu() {
  const [active, setActive] = useState("explore");

  const activeItem = navItems.find((item) => item.name === active);

  return (
    <div className="flex flex-col items-center space-y-4">
      {/* Navigation Menu */}
      <div className="flex space-x-2 bg-base-100 rounded-full border px-2 py-1 shadow-sm">
        {navItems.map(({ name }) => (
          <button
            key={name}
            onClick={() => setActive(name)}
            className={`flex items-center space-x-1 px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
              active === name
                ? "bg-base-200 text-base-content"
                : "text-base-content/80 hover:bg-base-100"
            }`}
          >
            <span>{name}</span>
          </button>
        ))}
      </div>

      {/* Content Area */}
      <div className="w-full max-w-md px-4 py-3 text-center rounded-xl">
        <p className="text-base-content/80">{activeItem?.description}</p>
      </div>
    </div>
  );
}
